import { render, staticRenderFns } from "./ratings.vue?vue&type=template&id=4ed3ec13"
import script from "./ratings.vue?vue&type=script&lang=ts"
export * from "./ratings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports